import { Button } from 'react-bootstrap'
import { Upload } from 'lucide-react'

export default function ImportButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button type='button' variant="success" size='sm' className='d-flex align-items-center create_btn import_btn ms-2' onClick={onClick}><Upload size={16} className='' />{button_name}</Button>
        </>
    )
}
